














































































import { defineComponent, ref, computed } from "@vue/composition-api";
import ProjectModel from "@/ts/models/projentClass";
import CaldatesInCard from "@c/molecules/caldate/CaldatesInCard.vue";
import TinyAvatar from "@c/atoms/user/TinyAvatar.vue";
import ImageModel from "@/ts/models/imageClass";
import TagsInCard from "@c/molecules/card/TagsInCard.vue";

export default defineComponent({
  name: "ProjentCard",

  components: {
    TagsInCard,
    CaldatesInCard,
    TinyAvatar
  },

  props: {
    type: String,
    projent: Object as () => ProjectModel,
    withPlace: {
      type: Boolean,
      default: false
    },
    withLocation: {
      type: Boolean,
      default: false
    }
  },

  setup(props, context) {
    var image: any = computed(() => {
      if (props.projent && props.projent.image) {
        return props.projent.image;
      } else {
        return new ImageModel();
      }
    });

    var place_image;

    if (props.projent && props.projent.place && props.projent.place.image) {
      place_image = props.projent.place.image;
    } else {
      place_image = new ImageModel();
    }

    const addFavorite = () => {
      //
    };

    return {
      addFavorite,
      image,
      place_image
    };
  }
});
